
export default function About() {
  return (
    <div className="bg-stone-50 py-32">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-teal-100 rounded-full mb-8">
              <span className="text-xs font-semibold text-teal-800 tracking-wider uppercase">
                About REM OOD
              </span>
            </div>
            <h3 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
              Team of Experts<br />Developing Modern<br />Applications
            </h3>
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed max-w-md">
              <p>
                REM OOD is a dedicated team of experts specializing in developing cutting-edge applications for the iOS platform. Our focus is on creating products that not only meet but exceed user expectations.
              </p>
              <p>
                With our flagship products like VPN and Cleaner, we are committed to enhancing user experience while ensuring the highest level of security for mobile devices. Our innovative approach combines technical excellence with user-centric design.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-6">
                <div className="bg-white rounded-2xl shadow-lg p-8 transform translate-y-8">
                  <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-3xl text-teal-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">Security First</h4>
                  <p className="text-gray-600 text-sm">Advanced protection for your mobile devices</p>
                </div>
                <div className="bg-white rounded-2xl shadow-lg p-8">
                  <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-smartphone-line text-3xl text-blue-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">iOS Expertise</h4>
                  <p className="text-gray-600 text-sm">Specialized in iOS platform development</p>
                </div>
              </div>
              <div className="space-y-6 pt-16">
                <div className="bg-white rounded-2xl shadow-lg p-8">
                  <div className="w-16 h-16 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-user-heart-line text-3xl text-purple-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">User Focused</h4>
                  <p className="text-gray-600 text-sm">Designed with user experience in mind</p>
                </div>
                <div className="bg-white rounded-2xl shadow-lg p-8">
                  <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-rocket-line text-3xl text-orange-600"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">Innovation</h4>
                  <p className="text-gray-600 text-sm">Cutting-edge technology solutions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
